import {
  isReservation,
  type ServiceOccupant,
} from 'restaurantAdmin/reservations/service/apiHelpers';
import { groupBy } from 'lodash-es';

export interface EventOption {
  id: string;
  name: string;
}

export const getEventOptions = (
  occupants: ServiceOccupant[],
): EventOption[] => {
  const optionsById = new Map<string, EventOption>();

  occupants.forEach((occupant) => {
    if (
      isReservation(occupant) &&
      occupant.restaurantEventId &&
      occupant.eventName
    ) {
      optionsById.set(occupant.restaurantEventId, {
        id: occupant.restaurantEventId,
        name: occupant.eventName,
      });
    }
  });

  return [...optionsById.values()].sort((a, b) => a.name.localeCompare(b.name));
};

export const filterOccupantsByEvent = (
  occupants: ServiceOccupant[],
  eventId: string | null,
): ServiceOccupant[] =>
  eventId
    ? occupants.filter(
        (occupant) =>
          isReservation(occupant) && occupant.restaurantEventId === eventId,
      )
    : occupants;

export const groupOccupantsByStatus = (occupants: ServiceOccupant[]) => {
  const groupedOccupants = groupBy(occupants, (occupant) => {
    if (['canceled', 'noShow'].includes(occupant.status)) {
      return 'removed';
    }
    if (['finished', 'autoResolved'].includes(occupant.status)) {
      return 'finished';
    }
    if (isReservation(occupant) && occupant.isAdmitted) {
      return 'admitted';
    }
    return occupant.seatedTableName ? 'seated' : 'upcoming';
  });

  return {
    seated: groupedOccupants.seated || [],
    upcoming: groupedOccupants.upcoming || [],
    admitted: groupedOccupants.admitted || [],
    finished: groupedOccupants.finished || [],
    removed: groupedOccupants.removed || [],
  };
};
